import React, { useState } from 'react';
import { Label } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Col, Row } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import BulkUploadBox from './BulkUpload';
import CenterSpinner from '../../components/CenterSpinner';
import { useLoader } from '../../loader/LoaderProvider';
import axios from 'axios';

interface ICreateLeadPageProps {
  title?: string;
}

const CreateBulkLeadPage: React.FunctionComponent<ICreateLeadPageProps> = ({
  title,
}: ICreateLeadPageProps) => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ loading: false, message: '' });
  const { showLoader, setShowLoader } = useLoader();
  const handleDownload = () => {
    // 1) Prepare your data (include headers in the first row)
    const headers = [
      'Name',
      'Crop',
      'Mobile Number',
      'Loan Amount',
      'State',
      'District',
      'Village',
      'Pincode',
    ];
    const rows: any = [];
    const data = [headers, ...rows];

    // 2) Create a worksheet from the 2D array
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Optional: column widths
    ws['!cols'] = [
      { wch: 20 },
      { wch: 12 },
      { wch: 28 },
      { wch: 20 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
    ];

    // Optional: freeze top row (headers)
    ws['!freeze'] = { xSplit: 0, ySplit: 1 };

    // 3) Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');

    // 4) Write the workbook to a Blob and download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, 'BulkLeadFormat.xlsx');
  };

  const onFileChange = (e: any) => {
    const f = e.target.files?.[0] || null;
    if (!f) return;

    // Basic validation: type + size (e.g., <= 10 MB)
    const validMimeTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ];
    const validExtensions = ['.xlsx'];
    const hasValidExt = validExtensions.some((ext) =>
      f.name.toLowerCase().endsWith(ext)
    );
    const hasValidMime = validMimeTypes.includes(f.type) || f.type === ''; // Some browsers may return empty string

    if (!hasValidExt || !hasValidMime) {
      setStatus({
        loading: false,
        message: 'Please select a valid .xlsx file.',
      });
      e.target.value = ''; // reset input
      return;
    }

    const MAX_SIZE = 10 * 1024 * 1024; // 10MB
    if (f.size > MAX_SIZE) {
      setStatus({
        loading: false,
        message: 'File is too large. Max size is 10MB.',
      });
      e.target.value = '';
      return;
    }

    setStatus({ loading: false, message: '' });
    setFile(f);
  };

  // const onSubmit = async (e: any) => {
  //   e.preventDefault();
  //   if (!file) {
  //     setStatus({ loading: false, message: 'Please choose a file first.' });
  //     return;
  //   }

  //   try {
  //     setStatus({ loading: true, message: 'Uploading...' });

  //     const formData = new FormData();
  //     // 'file' should match what your backend expects for the field name
  //     formData.append('file', file, file.name);

  //     // Add any other form fields if needed:
  //     // formData.append("someId", "123");

  //     const res = await fetch('/api/upload/excel', {
  //       method: 'POST',
  //       body: formData,
  //       // Note: Do NOT set Content-Type; the browser will set the correct multipart boundary.
  //       // headers: { Authorization: `Bearer ${token}` } // if needed
  //       credentials: 'include', // if your API requires cookies (optional)
  //     });

  //     if (!res.ok) {
  //       const text = await res.text().catch(() => '');
  //       throw new Error(text || `Upload failed with status ${res.status}`);
  //     }

  //     setStatus({ loading: false, message: 'File uploaded successfully ✅' });
  //     setFile(null);
  //     (document.getElementById('excelInput') || {}).value = ''; // reset input
  //   } catch (err) {
  //     setStatus({
  //       loading: false,
  //       message: `Error: ${err.message || 'Upload failed'}`,
  //     });
  //   }
  // };

  const validateUsersFile = async (file: File) => {
    const form = new FormData();
    form.append('file', file);

    const { data } = await axios.post('/api/users/bulk/validate', form);

    return data as {
      canImport: boolean;
      message?: string;
    };
  };

  return (
    <div>
      <Label className="text-heading">{title ?? 'Upload Lead'}</Label>
      <div className="container-parent task-item-parent-view">
        <Row className="task-details pb-2">
          <Col xs={12} md={12}>
            <div className="inner-div mt-2">
              <BulkUploadBox
                handleDownload={handleDownload}
                onFileChange={(file: any) => onFileChange(file)}
                status={status}
                onValidate={validateUsersFile}
              />
            </div>
          </Col>
        </Row>
      </div>
      <CenterSpinner showLoader={showLoader} />
    </div>
  );
};

export default CreateBulkLeadPage;
